import {
  POSTCARD_STORE_REQUEST,
  POSTCARD_STORE_SUCCESS,
  POSTCARD_STORE_FAILURE,
  POSTCARD_REQUEST,
  POSTCARD_SUCCESS,
  POSTCARD_FAILURE,  
} from '../actions/PostcardActions'

export function postcard(state = {
  data: {},
  errorMesage: ''
}, action) {
  switch(action.type) {
    case POSTCARD_STORE_REQUEST:
      return {
        ...state
      }
    case POSTCARD_STORE_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case POSTCARD_STORE_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }
    case POSTCARD_REQUEST:
      return {
        ...state
      }
    case POSTCARD_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case POSTCARD_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }      
    default:
      return state     
  }
}


// WEBPACK FOOTER //
// ./src/reducers/PostcardReducer.js